<template>
    <content-view>
        <template #header>
            <div class="home-head">
                <bread-crumb :buttonColor="'#005AB4'" :activeText="getDayFromMenu()"></bread-crumb>
                <v-spacer></v-spacer>
                <div class="sub-header">{{ $t("menu.entry-headline") }}</div>
            </div>
        </template>
        
        <template #content>
            <div class="content-wrapper">
                <v-card rounded="xl" elevation="9">
                    <v-img class="menu-entry-header-wrapper" :style="{backgroundColor: '#005AB4'}">
                        <v-card-text class="d-flex menu-entry-headline-text justify-center align-center">
                            <v-btn  :to="{name: 'menuEntry', params: {date: getPreviousDay()}}" :disabled="isFirstDay" :class="{hide: isFirstDay}" class="change-day-button">
                                <v-icon class="change-day-icon">mdi-menu-left</v-icon>
                            </v-btn>
                            <span style="width: 35vw;">{{getDayFromMenu()}}</span>
                            <v-btn :to="{name: 'menuEntry', params: {date: getNextDay()}}" class="change-day-button" :disabled="isLastDay" :class="{hide: isLastDay}">
                                <v-icon class="change-day-icon">mdi-menu-right</v-icon>
                            </v-btn>
                        </v-card-text>
                    </v-img>
                    <div class="meal-wrapper" v-if="menu !== undefined">
                        <meal-view v-if="menu.meals[0]" :meal="menu.meals[0]" :menuDescription="'Menu 1'"></meal-view>
                    <v-row class="menu-entry-empty-text empty-meal d-flex justify-center align-center" v-else-if="menu.meals.length === 0">{{ $t("menu.entry-empty") }}</v-row>
                    <v-row v-else class="empty-meal"></v-row>
                        <v-divider class="middle-divider meal-divider" :class="{hide: menu.meals.length === 0}"></v-divider>
                        <meal-view v-if="menu.meals[1]" :meal="menu.meals[1]" :menuDescription="'Menu 2'"></meal-view>
                    <v-row v-else class="empty-meal"></v-row>
                    </div>
                </v-card>
                <div class="menu-info-text">{{ $t("menu.entry-additional-info") }} <span class="bold">{{ $t("menu.entry-additional-info-phone") }}</span></div>
            </div>
        </template>
    </content-view>
</template>
<style lang="scss">
.content-wrapper {
    display: grid;
    grid-template-rows: auto;
    height: 100%;
}
.empty-meal {
    min-height: 20vh;
    height: 20vh;
    max-height: 20vh;
}
.change-day-button{
    height: 6vh !important;
    width: 4.5vw !important;
    border-radius: 1.2vh !important;
    margin: 0 3vw;
}
.change-day-icon{
    font-size: 8vh !important;
    color: $font-color !important;
}
.meal-wrapper{
    height: calc(100% - 10vh);
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    padding: 3vh 3vw;
}
.meal-divider {
    margin: 3vh 0;
}
.menu-entry-header-wrapper{
    height: 9vh;
}
.menu-entry-headline-text{
    height: 100%;
    text-align: center; //ist für längere Texte zusätzlich notwendig
    font: normal normal bold 3.5vh/6vh 'RobotoRegular' !important;
    letter-spacing: 2px !important;
    color: white !important;
}
.menu-entry-empty-text{
    height: 100%;
    text-align: center; //ist für längere Texte zusätzlich notwendig
    font: normal normal bold 3.5vh/6vh 'RobotoRegular' !important;
    letter-spacing: 3px !important;
    color: $font-color !important;
}
.menu-info-text{
    height: 2vh;
    margin-top: 1vh;
    text-align: center; //ist für längere Texte zusätzlich notwendig
    font: normal normal normal 1.7vh/3vh 'RobotoRegular' ;
    letter-spacing: 0.57px ;
    color: $font-color ;
}
.bold {
    font-weight: bold;
}
.hide {
    opacity: 0;
}
</style>
<script>
import moment from 'moment';
export default {
    data() {
        return {
            loading: true,
            daySpan: 6,
        }
    },
    created() {
        let now = moment(moment.now());
        this.$store.dispatch({
            type: 'moduleMenus/fetchMenus',
            startDate: now.subtract(this.daySpan, 'days').format('YYYY-MM-DD'),
            endDate: now.add(this.daySpan*2, 'days').format('YYYY-MM-DD'),
        }).catch((error) => {
            if(error.response.status === 401) {
                this.$root.$emit('unauthenticated');
            } else {
                this.apiErrorMessageHandler(error);
            }
        });
    },
    methods: {
        getMenuForDate(date) {
            return this.menus.filter(menu => {return menu.date === date})[0];
        },
        getDayFromMenu() {
            let format = 'dddd, DD.MM.YYYY';
            if(this.menu === undefined) {
                return moment(moment.now()).locale('de').format(format);
            } else if(this.isToday) {
                format = '[Heute], DD.MM.YYYY'
            }
            return moment(this.menu.date).locale('de').format(format);
        },
        getPreviousDay() {
            return moment(this.$route.params.date).subtract(1, 'days').format('YYYY-MM-DD');
        },
        getNextDay() {
            return moment(this.$route.params.date).add(1, 'days').format('YYYY-MM-DD');
        },
    },
    computed: {
        isFirstDay() {
            let firstDay = moment(moment.now()).subtract(this.daySpan, 'days').format('YYYY-MM-DD');
            return moment(this.menu?.date).isSame(firstDay);
        },
        isToday() {
            let today = moment(moment.now()).format('YYYY-MM-DD');
            return moment(this.menu?.date).isSame(today);
        },
        isLastDay() {
            let lasttDay = moment(moment.now()).add(this.daySpan, 'days').format('YYYY-MM-DD');
            return moment(this.menu?.date).isSame(lasttDay);
        },
        menus() {
            return this.$store.getters['moduleMenus/menus'];
        },
        menu() {
            return this.getMenuForDate(this.$route.params.date);
        }
    }
}
</script>
